import cleanUpResponse from "@/util/cleanUpResponse";

export default async function GetPRTNROrderTotalByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetPRTNROrderTotalByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId,
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        totalMonoNiprQuantity: '$..TotalMonoNIPRQuantity',
        totalMonoNiprPrice: '$..TotalMonoNIPRPrice',
        totalColorNiprQuantity: '$..TotalColorNIPRQuantity',
        totalColorNiprPrice: '$..TotalColorNIPRPrice',
        totalMonoSiprQuantity: '$..TotalMonoSIPRQuantity',
        totalMonoSiprPrice: '$..TotalMonoSIPRPrice',
        totalColorSiprQuantity: '$..TotalColorSIPRQuantity',
        totalColorSiprPrice: '$..TotalColorSIPRPrice',
        totalMonoQuantity: '$..TotalMonoQuantity',
        totalMonoPrice: '$..TotalMonoPrice',
        totalColorQuantity: '$..TotalColorQuantity',
        totalColorPrice: '$..TotalColorPrice',
        totalMonthlyQuantity: '$..TotalMonthlyQuantity',
        totalMonthlyPrice: '$..TotalMonthlyPrice',
        totalOneTimeYearlyQuantity: '$..TotalOneTimeYearlyQuantity',
        totalOneTimeYearlyPrice: '$..TotalOneTimeYearlyPrice',
        totalMonthlyAdditionalServicesQuantity: '$..TotalMonthlyAdditionalServicesQuantity',
        totalMonthlyAdditionalServicesPrice: '$..TotalMonthlyAdditionalServicesPrice',
        totalYearlyOneTimeServicesQuantity: '$..TotalYearlyOneTimeServicesQuantity',
        totalYearlyOneTimeServicesPrice: '$..TotalYearlyOneTimeServicesPrice'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}